import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'common';
import { getAppConfigSetting, requests, keyValToQueryString } from 'utils';
import { URL, PAGE_SIZE } from './constants';
import { TRANSFER_DIRECTIONS } from '../search';


export function searchRequest(apexAccountNumber) {
  const sixtyDaysAgo =
    moment(moment().hour(0).minute(0).second(0), DEFAULT_DATE_FORMAT)
      .subtract(60, 'd')
      .utcOffset(moment().utcOffset())
      .format();
  const today =
    moment(moment().hour(23).minute(45).second(0), DEFAULT_DATE_FORMAT)
      .utcOffset(moment().utcOffset())
      .format();

  // TODO: make this work with queryString.stringify.
  //  Then we can get rid of keyValToQueryString.
  const params = keyValToQueryString({
    page_size: PAGE_SIZE,
    start_date: sixtyDaysAgo,
    end_date: today,
    direction: TRANSFER_DIRECTIONS.transferDirectionDeposit,
    apex_account: apexAccountNumber,
  });

  return requests.get(`${URL(getAppConfigSetting('apiUrl'))}?${params}`);
}



// WEBPACK FOOTER //
// ./src/services/recentDeposits/api.js